import React = require("react");
import { features } from "../../features";

export const GoogleTranslateDropdown = (props: { mobile?: boolean, wrapper?: (children) => JSX.Element }) => {
  const f = features()
  if (f.automatedTranslations == 'off') return <></>
  const { wrapper, mobile } = props
  const { iconFill } = f.automatedTranslations
  const ids = googleTranslatorIds
  const dropdown = <>
    <div id={ids.element}></div>
    <div id={ids.languages}>
      <svg
        className="google_languages-icon"
        aria-hidden="true"
        fill="none"
        height="8"
        viewBox="0 0 14 10"
        width="12"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          clipRule="evenodd"
          d="m.324282.989902c.407119-.373192 1.039688-.345689 1.412878.061428l5.26285 5.74129 5.26289-5.74129c.3731-.407117 1.0057-.43462 1.4128-.061428.4071.373188.4347 1.005758.0615 1.412878l-6.00004 6.54546c-.18941.20663-.45685.32428-.73715.32428-.28031 0-.54775-.11765-.73716-.32428l-5.999999-6.54546c-.373192-.40712-.3456886-1.03969.061431-1.412878z"
          fill={iconFill}
          fillRule="evenodd"
        />
      </svg>
      <div id={ids.container}>
        {!mobile && <label htmlFor="google_language_selector" id={ids.label}>Selecteer een taal</label>}
        <select id={ids.placeholder} className="goog-te-combo placeholder notranslate">
          <option value=""></option>
        </select>
      </div>
    </div>
  </>

  return wrapper ? wrapper(dropdown) : dropdown
}

interface GoogleTranslatorIDs {
  element: string
  languages: string
  container: string
  label: string
  placeholder: string
}

const googleTranslatorIds: GoogleTranslatorIDs = {
  element: 'google_translate_element',
  languages: 'google_languages',
  container: 'google_languages_container',
  label: 'accesibility-label',
  placeholder: 'google_languages_placeholder'
}